module.exports = __webpack_public_path__ + "img/send.c0683840.svg";